import { Stack } from '@mui/material';
import ChannelBreakdownDefinitions from 'pages/loyalty-performance-report/loyalty-performance-api-definitions/channel-breakdown-definitions/channel-breakdown-definitions.component';
import MembershipDefinitions from 'pages/loyalty-performance-report/loyalty-performance-api-definitions/membership-definitions/membership-definitions.component';
import OfferDefinitions from 'pages/loyalty-performance-report/loyalty-performance-api-definitions/offer-definitions/offer-definitions.component';
import SalesAndRevenueDefinitions from 'pages/loyalty-performance-report/loyalty-performance-api-definitions/sales-and-revenue-definitions/sales-and-revenue-definitions.component';
import OrderDefinitions from 'pages/loyalty-performance-report/loyalty-performance-api-definitions/order-definitions/order-definitions.component';
import UniqueUserDefinitions from 'pages/loyalty-performance-report/loyalty-performance-api-definitions/unique-user-definitions/unique-user-definitions.component';

const LoyaltyOfferPerformanceApiDefinitions = () => {
  return (
    <Stack spacing={2}>
      <OfferDefinitions />
      <MembershipDefinitions isOffer />
      <OrderDefinitions />
      <SalesAndRevenueDefinitions isOffer />
      <ChannelBreakdownDefinitions isOffer />
      <UniqueUserDefinitions />
    </Stack>
  );
};

export default LoyaltyOfferPerformanceApiDefinitions;
